export const ENTERPRISE_SITE_KEY = '6Ld0J8IcAAAAANyrnxzrRlX1xrrdXsOmsepUYosy';
export const ENTERPRISE_SITE_KEY_V3 =
  '6LejsO4qAAAAAOm0iW-sqM4CzL0-wQpFmvFLkAxR';
